import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Faq from './views/Faq.vue'
import Links from './views/Links.vue'
import Other from './views/Other.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/about',
			name: 'about',
			component: About
		},
		{
			path: '/faq',
			name: 'faq',
			component: Faq
		},

		{
			path: '/links',
			name: 'links',
			component: Links
		},

		{
			path: '/schedule',
			name: 'schedule',
			component: Other
		}
	],
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 };
  	}
})
